import * as Sentry from "@sentry/browser";

import { captureEvent, captureException } from "@/lib/posthog";

export class ApiUnreachableError extends Error {
  constructor(message = "API unreachable") {
    super(message);
    this.name = "ApiUnreachableError";
  }
}

/** Safe to call unconditionally: Sentry and PostHog are no-ops when not initialised. */
export function reportApiUnreachable(context?: Record<string, unknown>): void {
  Sentry.captureException(new ApiUnreachableError(), {
    level: "fatal",
    tags: { kind: "api_unreachable" },
    fingerprint: ["api-unreachable"],
    extra: context,
  });
  captureException(new ApiUnreachableError(), {
    ...context,
    $exception_fingerprint: "api-unreachable",
  });
}

export function reportNotFound(pathname: string): void {
  const referrer = document.referrer || undefined;
  Sentry.captureMessage("404 Not Found", {
    level: "warning",
    tags: { kind: "not_found" },
    fingerprint: ["not-found"],
    extra: { pathname, referrer },
  });
  captureEvent("page_not_found", { pathname, referrer });
}
